module.exports = __webpack_public_path__ + "img/1.578231ea.png";